module.exports = __webpack_public_path__ + "static/media/Poppins-RegularItalic-latin.a242ba0d.woff2";